import { SITE_NAME } from '@/config';
import routes from '@/routes';

export default [
	{
		title: SITE_NAME,
		links: [
			{
				text: 'navigation.pricing',
				to: routes.pricing
			},
			{
				text: 'navigation.contact',
				to: routes.contact
			},
			{
				text: 'navigation.unsubscribe',
				to: routes.unsubscribe
			}
		]
	},
	{
		title: 'common.company',
		links: [
			{
				text: 'navigation.terms',
				to: routes.terms
			},
			{
				text: 'navigation.privacy',
				to: routes.privacyPolicy
			},
			{
				text: 'navigation.cookies',
				to: routes.cookiesPolicy
			},
			{
				text: 'navigation.faqs',
				to: routes.faqs
			},
			{
				text: 'navigation.gdpr',
				to: routes.gdpr
			}
		]
	}
];
